var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-cont"},[_c('div',{staticClass:"page-name help-detail-top"},[_vm._v("隐私政策")]),_c('div',{staticClass:"help-detail-right",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }